/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentType/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function AppointmentType({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/RescheduleQueue/AppointmentQueue/Content/Appointment/AppointmentType"
  
}) {
let eventAppointmentTypeDisplayNameValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.type.display_name',
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="event.appointment.type.display_name"
 text={eventAppointmentTypeDisplayNameValueData}
 weight="regular"
 size="small"
/>
{children}
</React.Fragment>)
}